// extracted by mini-css-extract-plugin
export default {"small":"CQuRbv8lWk"};